import {
  cardClasses,
  cardHeaderClasses,
  cardOrderClasses,
  cardTitleClasses,
} from './lifecareStudioClasses';
import useLifecareStudioSectionCard from '../../hooks/useLifecareStudioSectionCard';

const LifecareStudioSectionCard = ({ order, title, actions, children }) => {
  const { hasHeader } = useLifecareStudioSectionCard({ title, order, actions });
  return (
    <section className={cardClasses}>
      {hasHeader && (
        <div className={cardHeaderClasses}>
          <div>
            {order && <span className={cardOrderClasses}>Section {order}</span>}
            {title && <h3 className={cardTitleClasses}>{title}</h3>}
          </div>
          {actions ? <div>{actions}</div> : null}
        </div>
      )}
      {children}
    </section>
  );
};

export default LifecareStudioSectionCard;
